<template>
    <div v-if="activityDuration" :class="{'order-info-base-info': isShowLabel}">
        <span :class="{'order-info-base-info__icon': isShowLabel}">
            <v-icon start size="x-small">mdi-timer-outline</v-icon>
            <span v-if="isShowLabel" class="text-body-2">{{ $t('duration') }}</span>
        </span>
        <span :class="{'order-info-base-info__text': isShowLabel}">{{ activityDuration }}</span>
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class ActivityDuration extends Vue {
        @Prop() days
        @Prop() time
        @Prop({default: false, type: Boolean}) isShowLabel

        get activityDuration() {
            if (this.time) {
                const hm = this.time.split(':')

                const hours = +hm[0]
                const minutes = +hm[1]

                return `${hours ? hours + ' ' + this.$t('hour', hours) : ''} ${
                    minutes ? minutes + ' ' + this.$t('minute', minutes) : ''
                } `
            } else {
                return this.days ? `${this.days} ${this.$t('day', this.days)}` : undefined
            }
        }
    }

    export default ActivityDuration
</script>
